import script from "./goods-spec-editor.vue?vue&type=script&lang=ts&setup=true"
export * from "./goods-spec-editor.vue?vue&type=script&lang=ts&setup=true"

import "./goods-spec-editor.vue?vue&type=style&index=0&id=6ad051f1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ad051f1"]])

export default __exports__